// This file is part of MinIO Console Server
// Copyright (c) 2021 MinIO, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <http://www.gnu.org/licenses/>.

import * as React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";

const CalendarIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 221.371 254.207">
        <path
          data-name="Trazado 412"
          d="M47.443 145.862h24.651c3.4 0 6.162-3.188 6.162-7.115s-2.762-7.115-6.162-7.115H47.443c-3.4 0-6.164 3.188-6.164 7.115s2.758 7.115 6.164 7.115z"
        />
        <path
          data-name="Trazado 413"
          d="M100.296 145.862h24.651c3.4 0 6.162-3.188 6.162-7.115s-2.76-7.115-6.162-7.115h-24.651c-3.4 0-6.162 3.188-6.162 7.115s2.762 7.115 6.162 7.115z"
        />
        <path
          data-name="Trazado 414"
          d="M148.612 145.862h24.651c3.4 0 6.162-3.188 6.162-7.115s-2.762-7.115-6.162-7.115h-24.651c-3.4 0-6.165 3.188-6.165 7.115s2.762 7.115 6.165 7.115z"
        />
        <path
          data-name="Trazado 415"
          d="M47.443 177.886h24.651c3.4 0 6.162-3.188 6.162-7.115s-2.762-7.115-6.162-7.115H47.443c-3.4 0-6.164 3.188-6.164 7.115s2.758 7.115 6.164 7.115z"
        />
        <path
          data-name="Trazado 416"
          d="M100.296 177.886h24.651c3.4 0 6.162-3.188 6.162-7.115s-2.76-7.115-6.162-7.115h-24.651c-3.4 0-6.162 3.188-6.162 7.115s2.762 7.115 6.162 7.115z"
        />
        <path
          data-name="Trazado 417"
          d="M148.612 177.886h24.651c3.4 0 6.162-3.188 6.162-7.115s-2.762-7.115-6.162-7.115h-24.651c-3.4 0-6.165 3.188-6.165 7.115s2.762 7.115 6.165 7.115z"
        />
        <path
          data-name="Trazado 418"
          d="M47.443 209.909h24.651c3.4 0 6.162-3.187 6.162-7.115s-2.762-7.115-6.162-7.115H47.443c-3.4 0-6.164 3.188-6.164 7.115s2.758 7.115 6.164 7.115z"
        />
        <path
          data-name="Trazado 419"
          d="M100.296 209.909h24.651c3.4 0 6.162-3.187 6.162-7.115s-2.76-7.115-6.162-7.115h-24.651c-3.4 0-6.162 3.188-6.162 7.115s2.762 7.115 6.162 7.115z"
        />
        <path
          data-name="Trazado 420"
          d="M148.612 209.909h24.651c3.4 0 6.162-3.187 6.162-7.115s-2.762-7.115-6.162-7.115h-24.651c-3.4 0-6.165 3.188-6.165 7.115s2.762 7.115 6.165 7.115z"
        />
        <path
          data-name="Trazado 421"
          d="M198.078 30.392h-15.951v-19.8a10.627 10.627 0 00-10.6-10.595 10.627 10.627 0 00-10.595 10.595v19.8h-40.089v-19.8a10.627 10.627 0 00-10.6-10.595 10.627 10.627 0 00-10.595 10.595v19.8H59.559v-19.8a10.627 10.627 0 00-10.6-10.595 10.627 10.627 0 00-10.595 10.595v19.8h-15.08A23.3 23.3 0 00-.011 53.687v177.225a23.294 23.294 0 0023.295 23.295h174.782a23.294 23.294 0 0023.295-23.295V53.687a23.294 23.294 0 00-23.283-23.295zm-3.051 197.409a.061.061 0 01-.062.062H26.408a.062.062 0 01-.064-.062V113.844h168.683z"
        />
      </svg>
    </SvgIcon>
  );
};

export default CalendarIcon;
